import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import BannerImage from '@acorn-portal/shared/src/assets/acorn/lander_banner.webp';

interface IProps {
	text?: React.ReactNode;
}

const AcornLanderBanner: FC<IProps> = ({ text }) => {
	return (
		<Box
			sx={(theme) => ({
				position: 'relative',
				backgroundImage: `url(${BannerImage})`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
				backgroundPosition: 'center center',
				padding: 2,
				overflow: 'hidden',
				paddingBottom: '40%',
				[theme.breakpoints.down('md')]: {
					height: '250px',
					backgroundSize: 'cover',
					backgroundPosition: 'center bottom',
				},
			})}
		>
			<Box
				sx={(theme) => ({
					position: 'absolute',
					zIndex: 200,
					top: '15%',
					left: '2rem', // Adjusted the left position
					transform: 'translateY(-50%)',
					overflow: 'hidden',
					width: 'auto',
					maxWidth: '50%',
					[theme.breakpoints.down('md')]: {
						left: '1.5rem',
						fontSize: '4vw',
						maxWidth: '80%',
					},
					[theme.breakpoints.down('sm')]: {
						left: '0',
						fontSize: '5vw',
					},
				})}
			>
				<Typography
					variant='h4'
					sx={(theme) => ({
						color: theme.palette.common.white,
						fontSize: '1.8rem',
						margin: '1.8rem',
						padding: '1rem',
						fontWeight: 500,
						[theme.breakpoints.down('md')]: {
							fontSize: '1.5rem',
							margin: '1rem',
							padding: '0.8rem',
						},
						[theme.breakpoints.down('sm')]: {
							fontSize: '1.2rem',
							margin: '0.7rem',
							padding: '0.6rem',
						},
					})}
				>
					{text}
				</Typography>
			</Box>
		</Box>
	);
};
export default AcornLanderBanner;
